import { ArrowRight, Play, Sparkles } from "lucide-react";

/**
 * FinalCtaSection — cinematic ending. Black background, cinematic
 * future-vision image of students + LemonBot looking forward,
 * three CTAs.
 */
export default function FinalCtaSection({ onPrimary, onDemo, onPartner }) {
  return (
    <section
      id="final-cta"
      className="relative bg-[#0A0A0A] text-white py-20 sm:py-28 overflow-hidden"
      data-testid="final-cta-section"
    >
      <div aria-hidden="true" className="absolute -top-32 -left-32 w-[36rem] h-[36rem] rounded-full bg-[#FFD500]/15 blur-3xl lsbp-pulse-glow" />
      <div aria-hidden="true" className="absolute -bottom-32 -right-32 w-[32rem] h-[32rem] rounded-full bg-[#00E65C]/15 blur-3xl lsbp-pulse-glow" style={{ animationDelay: "1.5s" }} />

      <div className="relative max-w-7xl mx-auto px-4 lg:px-6 grid lg:grid-cols-12 gap-10 items-center">
        {/* Left — copy */}
        <div className="lg:col-span-6 text-center lg:text-left">
          <div className="inline-flex items-center gap-2 bg-white/10 text-[#FFD500] px-3 py-1.5 rounded-full text-[11px] font-black tracking-widest uppercase mb-5">
            <Sparkles className="w-3.5 h-3.5" /> Get Started Today
          </div>
          <h2 className="text-[32px] md:text-5xl font-black tracking-tighter leading-[0.98]">
            Big Ideas{" "}
            <span className="text-[#FFD500]">Start</span>{" "}
            <span className="text-[#00E65C]">Here.</span>
          </h2>
          <p className="mt-5 text-base md:text-xl text-gray-300 max-w-xl mx-auto lg:mx-0">
            Help students learn, lead, create, and build their future through
            entrepreneurship and responsible AI-powered learning.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center lg:justify-start" data-testid="final-cta-buttons">
            <button
              onClick={onPrimary}
              className="inline-flex items-center justify-center gap-2 bg-[#FFD500] text-black px-7 py-4 rounded-full text-lg font-bold hover:bg-white transition-colors shadow-[0_12px_30px_rgba(255,213,0,0.3)]"
              data-testid="final-cta-start"
            >
              Start Learning <ArrowRight className="w-4 h-4" />
            </button>
            <button
              onClick={onDemo}
              className="inline-flex items-center justify-center gap-2 bg-white text-black px-6 py-4 rounded-full text-lg font-bold hover:bg-[#00E65C] transition-colors"
              data-testid="final-cta-demo"
            >
              <Play className="w-4 h-4" /> Book A Demo
            </button>
            <button
              onClick={onPartner}
              className="inline-flex items-center justify-center gap-2 bg-transparent ring-2 ring-white/30 text-white px-6 py-4 rounded-full text-lg font-bold hover:ring-[#FFD500] hover:text-[#FFD500] transition-colors"
              data-testid="final-cta-partner"
            >
              Partner With Us
            </button>
          </div>
        </div>

        {/* Right — cinematic image */}
        <div className="lg:col-span-6">
          <div className="rounded-3xl overflow-hidden ring-1 ring-white/10 shadow-[0_30px_60px_rgba(255,213,0,0.15)]">
            <img
              src="/assets/landing/final-cta-future.png"
              alt="Students looking toward a bright future with LemonBot and entrepreneurship learning visuals."
              className="w-full h-auto block"
              loading="lazy"
              data-testid="final-cta-feature-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
